module.exports["checkbox"] = "_checkbox_ff609b";
module.exports["darkModeToggle"] = "_darkModeToggle_ff609b";
module.exports["focus-visible"] = "_focus-visible_ff609b";